import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupRecords'
})
export class GroupRecordsPipe implements PipeTransform {
  transform(records: any[] | undefined, groupId: number | undefined): any[] {
    if (!records || !Array.isArray(records) || groupId === undefined) {
      return [];
    }
    return records.filter(record => record.LOANGROUPID === groupId);
  }
}
